export interface SalesOrderRow {
  id: number
  code: string
  reference: string
  warehouse: string
  orderDate: string
  expectedDeliveryDate: string
  total: number
  /** True when the order form set Is Delivery Challan = Yes (`IsDcRequired`). */
  isDcRequired: boolean
  /** True when the order was converted to an invoice (`OrderStatus` 4). */
  isInvoiceCreated: boolean
  /** True when the order was converted to a delivery challan (`OrderStatus` 5). */
  isDcCreated: boolean
}

export type SalesOrderLine = {
  id: number
  itemId: string
  batchId: string
  availableQuantity: number
  quantity: number
  unitPrice: number
  discountPercent: number
  unitCostPrice: number
  /** Selected tax rate lookup id (sent as `tax` on the API line JSON). */
  taxRateId: string
}

export const newSalesOrderLine = (): SalesOrderLine => ({
  id: 0,
  itemId: '',
  batchId: '',
  availableQuantity: 0,
  quantity: 0,
  unitPrice: 0,
  discountPercent: 0,
  unitCostPrice: 0,
  taxRateId: '',
})

